module.exports = __webpack_public_path__ + "static/media/Checkmark.539900fe.svg";